module.exports = __webpack_public_path__ + "static/media/Smoke.0a66d97b.jpg";